import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  emptyDateSubconditionState,
  numOrdersFromModel,
  validateNumOrdersCondition,
  type NumOrdersState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";
import {
  getDateSubconditionSuffix,
  toModelDateSubcondition,
} from "./date-subcondition";

export const NUM_ORDERS = (
  Details: React.ComponentType<ConditionTypeDetailsProps<NumOrdersState>>,
): ConditionType<NumOrdersState, Condition.NumOrders> => ({
  name: "Number of orders",
  description(state) {
    if (!state.orderOption) {
      return "The total number of orders this customer has placed";
    }

    let description = `Number of orders ${state.orderOption.toLowerCase()} ${state.numOrders}`;

    // Add date subcondition suffix from shared helper
    description += getDateSubconditionSuffix(state.dateSubcondition);

    return description;
  },
  Details(props: ConditionTypeDetailsProps<NumOrdersState>) {
    return React.createElement(Details, props);
  },
  empty: {
    numOrders: (0).toFixed(0),
    orderOption: null,
    dateSubcondition: emptyDateSubconditionState,
  },
  fromModel(model) {
    return numOrdersFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.NUM_ORDERS,
      numOrders: +state.numOrders,
      numOrdersOption: state.orderOption,
      // Use only dateSubcondition going forward
      dateSubcondition: toModelDateSubcondition(state.dateSubcondition),
    };
  },
  valid(state) {
    return validateNumOrdersCondition(state).valid;
  },
});

export { type NumOrdersState } from "@redotech/redo-model/return-flow/condition-validate";
